<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import { orderStore } from "../../services/order-options-service";
  import { SearchState } from "../../services/search-service";
  import OptionRow from "./OptionRow.svelte";

  const id = "bbox";
  export let option: OrderOption;

  // Default bbox
  orderStore.setOrderValue(id, [
    {
      id: id,
      value: "90,-180,-90,180",
      selected: true
    }
  ]);
</script>

<OptionRow
  {id}
  label="Bounding Box"
  tooltip="Edit the Bounding Box by closing this modal and using the map tool."
>
  {#if $orderStore.options[id]}
    {#each $orderStore.values[id] as option}
      <div>{option.value}</div>
    {/each}
  {/if}
</OptionRow>
